import { __rest, __assign } from './../../../external/tslib/tslib.es6.js';
import React, { useState } from 'react';
import Input from '../Input.js';
import { SuffixIconInputPassword } from './SuffixIconInputPassword.js';

var InputPassword = function (_a) {
    var label = _a.label, helperText = _a.helperText, placeholder = _a.placeholder, props = __rest(_a, ["label", "helperText", "placeholder"]);
    var _b = useState(false), isPasswordVisible = _b[0], setIsPasswordVisible = _b[1];
    return (React.createElement(Input, __assign({ type: !isPasswordVisible ? 'password' : 'text', label: label, helperText: helperText, placeholder: placeholder, suffix: function () {
            return SuffixIconInputPassword(setIsPasswordVisible, isPasswordVisible);
        } }, props)));
};

export { InputPassword as default };
